<template>
  <!-- 内容 -->
  <div class="help_content">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item style="cursor: pointer !important;"><span style="color: #AB54DB;font-weight: bold;" @click="goBackHome()">{{ $t('help.help_center') }}</span></el-breadcrumb-item>
      <el-breadcrumb-item v-if="routePath == 'last'" style="cursor: pointer !important;"><span style="color: #AB54DB;" @click="goBackLast()">{{ $t('help.previous_page') }}</span></el-breadcrumb-item>
      <el-breadcrumb-item style="color: #72777E">{{ $t('help.faq') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="notice_list" style="margin-top: 30px">
      <div id="problem0">
        <div>
          <span style="display: inline-block; font-weight: bold; vertical-align: middle">{{ $t('problem.must_read_newbies') }}</span>
          <img style="display: inline-block; width: 16px; height: 16px; vertical-align: middle;margin-left: 10px" src="../../assets/img/help/remind.png">
        </div>
        <div style="display: block;margin-top: 6px;">
          <span style="font-size: 14px;">{{$t('problem.must_read_newbies_content1_1')}}</span>
          <span style="font-size: 14px; color: #FF4D4F">{{$t('problem.must_read_newbies_content1_2')}}</span>
          <span style="font-size: 14px;">{{$t('problem.must_read_newbies_content1_3')}}</span>
        </div>
<!--        <span style="font-size: 14px;">{{$t('problem.must_read_newbies_content1')}}</span>-->
        <div style="margin-top: 6px">
          <span style="font-size: 14px; color: #FF4D4F">{{$t('problem.must_read_newbies_content2_0')}}</span>
          <span style="font-size: 14px;">{{$t('problem.must_read_newbies_content2')}}</span>
        </div>
        <span style="font-size: 14px;display: block;margin-top: 6px">{{$t('problem.must_read_newbies_content3')}}</span>
      </div>
      <div id="problem1" style="margin-top: 20px">
        <span style="display: block; font-weight: bold">{{ $t('problem.product_info_title') }}</span>
        <span style="font-size: 14px;display: block;margin-top: 6px">{{ $t('problem.product_info') }}</span>
      </div>

      <div id="problem2" style="margin-top: 20px">
        <span style="display: block; font-weight: bold">{{ $t('problem.Exclusive_user_introduction') }}</span>
<!--        <span style="font-size: 14px;display: block;margin-top: 6px">Okx专属用户：通过OKX专属链接（https://www.lybg1688.com/join/UPLUS）或邀请码（UPLUS）注册的交易所会员。<br>币安专属用户：申请币安API，通过UPlus平台校验并绑定成功的用户。<br>专属用户权益：专属用户享受限时98%燃料费折扣。</span>-->
        <span style="font-size: 14px;display: block;margin-top: 6px">{{$t('problem.Exclusive_user_introduction_tip1')}}（{{ $registered_address.okx_address() }}）{{$t('problem.Exclusive_user_introduction_tip2')}}</span>
      </div>

      <div id="problem3" style="margin-top: 20px">
        <span style="display: block; font-weight: bold">{{ $t('problem.start_robot_condition') }}</span>
        <span style="font-size: 14px;display: block;margin-top: 6px">{{ $t('problem.start_robot_condition_tip') }}</span>
      </div>

      <div id="problem4" style="margin-top: 20px">
        <span style="display: block; font-weight: bold">{{ $t('problem.Strategy_Instructions') }}</span>
        <span style="font-size: 14px;display: block;margin-top: 6px">{{ $t('problem.Strategy_Instructions_tip') }}</span>
      </div>

      <div id="problem5" style="margin-top: 20px">
        <span style="display: block; font-weight: bold">{{ $t('problem.Contract_Trading_Instructions') }}</span>
<!--        <span style="font-size: 14px;display: block;margin-top: 6px">交易策略简单来理解属于多空对冲，利用区间波动以及多种算法，计算得出不同交易对的最优参数，来把握买进及卖出机会从而实现套利。</span>-->
        <span style="font-size: 14px;display: block;margin-top: 6px">{{ $t('problem.Contract_Trading_Instructions_tip') }}</span>
      </div>

      <div id="problem12" style="margin-top: 20px">
        <div>
          <span style="display: inline-block; font-weight: bold; vertical-align: middle">{{ $t('problem.floating_losses_explanation') }}</span>
          <img style="display: inline-block; width: 16px; height: 16px; vertical-align: middle;margin-left: 10px" src="../../assets/img/help/remind.png">
        </div>
        <span style="font-size: 14px;display: block;margin-top: 6px">{{ $t('problem.floating_losses_explanation_content') }}</span>
      </div>

      <div id="problem6" style="margin-top: 20px">
        <div>
          <span style="display: inline-block; font-weight: bold; vertical-align: middle">{{ $t('problem.Modify_position_description') }}</span>
          <img style="display: inline-block; width: 13px; height: 16px; vertical-align: middle;margin-left: 10px" src="../../assets/img/help/hot.png">
        </div>
        <span style="font-size: 14px;display: block;margin-top: 6px">{{ $t('problem.Modify_position_description_tip') }}</span>
      </div>

      <div id="problem7" style="margin-top: 20px">
        <div>
          <span style="display: inline-block; font-weight: bold; vertical-align: middle">{{ $t('problem.Stop_Loss_Instructions') }}</span>
          <img style="display: inline-block; width: 13px; height: 16px; vertical-align: middle;margin-left: 10px" src="../../assets/img/help/hot.png">
        </div>
        <span style="display: block; font-weight: 600;margin-top: 6px;font-size: 14px;">{{ $t('problem.Stop_Loss_Instructions_tip_title1') }}</span>
        <span style="font-size: 14px;display: block;margin-top: 6px">{{ $t('problem.Stop_Loss_Instructions_tip_content1') }}</span>
        <span style="display: block; font-weight: 600;margin-top: 6px;font-size: 14px;">{{ $t('problem.Stop_Loss_Instructions_tip_title2') }}</span>
        <span style="font-size: 14px;display: block;margin-top: 6px">{{ $t('problem.Stop_Loss_Instructions_tip_content2') }}</span>
      </div>

      <div id="problem8" style="margin-top: 20px">
        <div>
          <span style="display: inline-block; font-weight: bold; vertical-align: middle">{{ $t('problem.Deduction_Instructions') }}</span>
          <img style="display: inline-block; width: 13px; height: 16px; vertical-align: middle;margin-left: 10px" src="../../assets/img/help/hot.png">
        </div>
        <span style="font-size: 14px;display: block;margin-top: 6px">{{ $t('problem.Deduction_Instructions_tip') }}</span>
      </div>

      <div id="problem9" style="margin-top: 20px">
        <div>
          <span style="display: inline-block; font-weight: bold; vertical-align: middle">{{ $t('problem.Card_Fuel_Instructions') }}</span>
          <img style="display: inline-block; width: 13px; height: 16px; vertical-align: middle;margin-left: 10px" src="../../assets/img/help/hot.png">
        </div>
        <span style="font-size: 14px;display: block;margin-top: 6px">{{ $t('problem.Card_Fuel_Instructions_tip') }}</span>
      </div>

<!--      <div id="problem10" style="margin-top: 20px">-->
<!--        <div>-->
<!--          <span style="display: inline-block; font-weight: bold; vertical-align: middle">交易账户浮亏说明</span>-->
<!--          <img style="display: inline-block; width: 13px; height: 16px; vertical-align: middle;margin-left: 10px" src="../../assets/img/help/hot.png">-->
<!--        </div>-->
<!--        <span style="font-size: 14px;display: block;margin-top: 6px">{{ $t('problem.Trading_account_loss_tip') }}</span>-->
<!--      </div>-->

      <div id="problem11" style="margin-top: 20px">
        <span style="display: block; font-weight: bold">{{ $t('problem.Withdrawal_Instructions') }}</span>
        <span style="font-size: 14px;display: block;margin-top: 6px">{{ $t('problem.Withdrawal_Instructions_tip') }}</span>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "help_content_one",
  components: {},
  data(){
    return{
      noticeContent: {},
      id: '',
      routePath: '',
      problemId: ''
    }
  },

  created() {

  },

  mounted() {

  },

  activated() {
    this.$nextTick(()=>{
      this.routePath = this.$route.query.routePath
      this.problemId = this.$route.query.problemId
      if (this.problemId){
        document.querySelector('#'+this.problemId).scrollIntoView({
          behavior: "smooth",
          // 定义动画过渡效果， "auto"或 "smooth" 之一。默认为 "auto"
          block: "center",
          // 定义垂直方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "start"
          inline: "nearest"
          // 定义水平方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "nearest"
        })
        document.getElementById(this.problemId).className = 'div_flash'
        setTimeout(()=>{
          document.getElementById(this.problemId).className = 'div_flash_no'
        },1000)
      }
    })
  },

  methods: {
    goBackHome(){
      if (this.routePath == 'last'){
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    },
    goBackLast(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
span{
  color: #1E2329;
}

.div_flash{
  box-shadow: 0px 0px 33px rgba(34, 34, 44, 0.6);
  border-radius: 3px;
  animation-duration: 2s;
  padding: 10px;
}

.div_flash_no{
  box-shadow: unset;
  padding: 0;
  transition-duration: 1s
}

@media screen and (max-width: 900px){
  .help_content {
    /*width: 100%;*/
    margin-top: -27px;
    min-height: 450px;
    padding: 0 16px
  }
  .content_list {
    column-count: 1;
  }
  .content_list span{
    color: #464255;
    font-size: 14px;
  }
  .content_title {
    font-size: 24px;
    font-weight: 500;
    margin-top: 30px;
    display: block;
  }
  .auto_list{
    column-count: 3;
    text-align: center;
  }
  .notice_list{
    margin-bottom: 30px;
  }

  .el-container{
    display: block;
  }

  .help_content_top{
    background: #FFFFFF;
    width: 90%;
    height: 230px;
    text-align: center;
  }

  .help_content_top_left{
    margin-top: 20px;
  }
  .help_content_bg{
    text-align: center;
  }
}
@media screen and (min-width: 900px){
  .content_list {
    /*column-count: 4;*/
  }

  .content_list span{
    display: inline-block !important;
    color: #464255;
    width: 30%;
  }

  .auto_list{
    column-count: 6;
    text-align: center;
  }

  .notice_list{
    margin-bottom: 30px;
  }

  .notice_list span:nth-child(1){
    font-size: 16px;
  }
  .notice_list span:nth-child(2){
    font-size: 14px;
  }

  .help_content {
    width: 1200px;
    min-height: 795px;
    margin: 50px auto 0;
    padding: 0 16px
  }

  .content_title {
    display: block;
    font-size: 26px;
    font-weight: 500;
    margin-top: 30px;
  }

  .help_content_top{
    background: #FFFFFF;
    width: 380px;
    height: 260px;
    margin-right: 30px;
  }

  .help_content_top_left{
    margin-left: 30px;
  }

  .help_content_bg{
    text-align: unset;
  }
}
</style>
